import { CITATIONS_CONTAINER } from '../classnames/scientific-citations';
import { HIDDEN } from '../classnames/design-system';
import CitationsRenderer from './citations-renderer';
import CitationIndexesRenderer from './citation-indexes-renderer';
import ShowAllButton from './show-all-button';

export default class ScientificCitationsRenderer {
  citationsContainer = document.querySelector(`.${CITATIONS_CONTAINER}`);

  renderCitationsIndexes = () => {
    this.processedCitationsIds = (new CitationIndexesRenderer()).render();
  };

  renderCitationsList = () => {
    (new CitationsRenderer({ citationIds: this.processedCitationsIds })).render();
  };

  renderShowAllButton = () => {
    (new ShowAllButton({ count: this.processedCitationsIds.length })).render();
  };

  displayCitationLinks = () => {
    this.citationsContainer.classList.remove(HIDDEN);
  };

  render = () => {
    if (this.citationsContainer) {
      this.renderCitationsIndexes();
      this.renderCitationsList();
      this.displayCitationLinks();
      this.renderShowAllButton();
    }
  };
}
